import { isMobile } from "react-device-detect";
import UploadButton from "./UploadButton";
import AddIcon from "@mui/icons-material/Add";

const UploadImageButton = ({ onChange, disabled, accept, buttonProps, multiple = false, maxSizeMB }) => {
  return (
    <UploadButton
      onChange={onChange}
      disabled={disabled}
      label={isMobile ? "" : "Upload Image"}
      buttonProps={{
        variant: "contained",
        color: disabled ? "primary" : "secondary",
        sx: isMobile
          ? { maxWidth: 35, minWidth: 35, height: 35, backgroundColor: "white", borderRadius: 17.5, p: 0, ".MuiButton-startIcon": { margin: 0 } }
          : {
            pr: 1.5,
            pl: 1,
            py: 0,
            lineHeight: "35px",
            borderRadius: "20px",
          },
        startIcon: isMobile ? <AddIcon></AddIcon> : <img src={`assets/buttons/uploadimg${disabled ? "-disabled" : ""}.svg`} alt="Upload" />,
        ...buttonProps,
      }}
      inputProps={{ accept: accept || "image/*", multiple: multiple, maxSizeMB: maxSizeMB }}
    ></UploadButton>
  );
};

export default UploadImageButton;
